<template>
  <div v-if="node">
    <el-tabs  v-model="currentTab">

      <el-tab-pane label="Общие">
        <el-form
          size="mini"
          label-position="right"
          label-width="100px"
        >
          <el-row :gutter="100">
            <el-col :span="12">
              <el-form-item label="Название">
                <div style="display: flex">
                  <click-to-edit
                    v-model="node.model.name"
                    :disabled="!node.isFieldEditable('name')"
                    :placeholder="node.getHiddenPlaceholder('name')"
                    style="width: 100%"
                    @input="updateNode"
                  ></click-to-edit>
                  <div style="margin-left:30px;width: 50px;text-align: right">ID: {{ node.model.id }}</div>
                </div>
              </el-form-item>
              <el-form-item label="Описание">
                <click-to-edit
                  v-model="node.model.desc"
                  :disabled="!node.isFieldEditable('desc')"
                  :placeholder="node.getHiddenPlaceholder('desc')"
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 6}"
                  @input="updateNode"
                ></click-to-edit>
              </el-form-item>
              <el-form-item label="">
                <history-modal
                  title="История изменений цели"
                  width="70%"
                  :method="$api.cascading.elementGetHistory"
                  :params="{ id: node.id }"
                >
                  <el-button
                    slot="reference"
                    size="mini"
                    icon="fas fa-history"
                    @click.stop
                  >
                    История изменений
                  </el-button>
                </history-modal>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Шкала">
                <click-to-edit
                  v-model="node.model.scale_type"
                  type="select"
                  select-filterable
                  :select-options="$cascadingConstants.scales.typesSelectOptions"
                  :disabled="!node.isFieldEditable('scale_type')"
                  :placeholder="node.getHiddenPlaceholder('scale_type')"
                  @input="updateNode"
                ></click-to-edit>
              </el-form-item>
              <el-form-item
                :label="node.model.scale_type === $cascadingConstants.scales.types.TYPE_QUALITY ? 'Тип шкалы' :  'Ед.измерения'"
              >
                <cascading-scale-unit-select
                  v-if="node.isFieldViewable('scale_unit')"
                  v-model="node.model"
                  @change="updateNode"
                ></cascading-scale-unit-select>
                <CascadingElementHiddenProp v-else>{{node.getHiddenPlaceholder('scale_unit')}}</CascadingElementHiddenProp>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="Данные">
        <el-alert
          v-if="valuesDisabled"
          :closable="false"
          style="margin-bottom: 10px"
          type="warning"
          title="У цели есть дочерние цели"
          description="Текущие значения цели не участвуют в расчете производительности. Для игнорирования выберите ручной режим на вкладке производительность"
          show-icon
        ></el-alert>

        <el-form
          size="mini"
          label-position="right"
          label-width="180px"
        >
          <el-row :gutter="100">
            <el-col :span="8">
              <el-form-item label="Значение">
                <CascadingScalePerformanceValuesInput
                  v-if="node.isFieldViewable('value')"
                  :disabled="!node.isFieldEditable('value')"
                  v-model="node.model"
                  style="width: 100%"
                  performance-value-name="value"
                  @change="updateNode"
                ></CascadingScalePerformanceValuesInput>
                <CascadingElementHiddenProp v-else>{{node.getHiddenPlaceholder('value')}}</CascadingElementHiddenProp>
              </el-form-item>
              <el-form-item label="Расширенный режим">
                <el-switch
                  v-model="node.model.extended_performance_scale"
                  :inactive-value="false"
                  :active-value="true"
                  @change="updateNode"
                ></el-switch>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="Начальное">
                <CascadingScalePerformanceValuesInput
                  v-if="node.isFieldViewable('baseline')"
                  :disabled="!node.isFieldEditable('baseline')"
                  v-model="node.model"
                  style="width: 100%"
                  performance-value-name="baseline"
                  @change="updateNode"
                ></CascadingScalePerformanceValuesInput>
                <CascadingElementHiddenProp v-else>{{node.getHiddenPlaceholder('baseline')}}</CascadingElementHiddenProp>
              </el-form-item>
              <el-form-item label="Минимальное" v-if="node.model.extended_performance_scale">
                <CascadingScalePerformanceValuesInput
                  v-if="node.isFieldViewable('min')"
                  :disabled="!node.isFieldEditable('min')"
                  v-model="node.model"
                  performance-value-name="min"
                  @change="updateNode"
                ></CascadingScalePerformanceValuesInput>
                <CascadingElementHiddenProp v-else>{{node.getHiddenPlaceholder('min')}}</CascadingElementHiddenProp>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Цель">
                <CascadingScalePerformanceValuesInput
                  v-if="node.isFieldViewable('target')"
                  :disabled="!node.isFieldEditable('target')"
                  v-model="node.model"
                  style="width: 100%"
                  performance-value-name="target"
                  @change="updateNode"
                ></CascadingScalePerformanceValuesInput>
                <CascadingElementHiddenProp v-else>{{node.getHiddenPlaceholder('target')}}</CascadingElementHiddenProp>
              </el-form-item>
              <el-form-item label="Максимальное" v-if="node.model.extended_performance_scale">
                <CascadingScalePerformanceValuesInput
                  v-if="node.isFieldViewable('max')"
                  :disabled="!node.isFieldEditable('max')"
                  v-model="node.model"
                  performance-value-name="max"
                  @change="updateNode"
                ></CascadingScalePerformanceValuesInput>
                <CascadingElementHiddenProp v-else>{{node.getHiddenPlaceholder('max')}}</CascadingElementHiddenProp>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="Производительность">
        <el-alert
          v-if="performanceDisabled"
          :closable="false"
          style="margin-bottom: 10px"
          type="warning"
          title="У цели есть дочерние цели"
          description="Текущее значение производительности берется из дочерних элементов. Для игнорирования выберите ручной режим"
          show-icon
        ></el-alert>


        <el-form
          size="mini"
          label-position="right"
          label-width="280px"
        >
          <el-row :gutter="100">
            <el-col :span="12">
              <el-form-item label="Функция расчета">
                <PerformanceFormulaSelect
                  v-if="node.isFieldViewable('performance_formula_id')"
                  :disabled="!node.isFieldEditable('performance_formula_id')"
                  v-model="node.model"
                  @change="updateNode"
                ></PerformanceFormulaSelect>
                <CascadingElementHiddenProp v-else>{{node.getHiddenPlaceholder('performance_formula_id')}}</CascadingElementHiddenProp>
              </el-form-item>
              <el-form-item label="Вес">
                <click-to-edit
                  v-if="node.thisParentLink && node.isFieldViewable('weight')"
                  :disabled="!node.isFieldEditable('weight')"
                  v-model="node.thisParentLink.weight"
                  placeholder=""
                  digits-only
                  @input="updateNodeParentLink(node.thisParentLink)"
                ></click-to-edit>
                <CascadingElementHiddenProp v-else>{{node.getHiddenPlaceholder('weight')}}</CascadingElementHiddenProp>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Значение полей из дочерних">
                <click-to-edit
                  v-if="node.thisParentLink && node.isFieldViewable('child_values_aggregate_type')"
                  :disabled="!node.isFieldEditable('child_values_aggregate_type')"
                  v-model="node.model.child_values_aggregate_type"
                  type="select"
                  select-filterable
                  :select-options="$cascadingConstants.elementChildValuesAggregate.typesSelectOptions"
                  placeholder=""
                  @input="updateNode(node)"
                ></click-to-edit>
                <CascadingElementHiddenProp v-else>{{node.getHiddenPlaceholder('child_values_aggregate_type')}}</CascadingElementHiddenProp>
              </el-form-item>
              <el-form-item label="Значение результата из дочерних">
                <click-to-edit
                  v-if="node.thisParentLink && node.isFieldViewable('child_performance_aggregate_type')"
                  :disabled="!node.isFieldEditable('child_performance_aggregate_type')"
                  v-model="node.model.child_performance_aggregate_type"
                  type="select"
                  select-filterable
                  :select-options="$cascadingConstants.elementChildPerformanceAggregate.typesSelectOptions"
                  placeholder=""
                  @input="updateNode(node)"
                ></click-to-edit>
                <CascadingElementHiddenProp v-else>{{node.getHiddenPlaceholder('child_performance_aggregate_type')}}</CascadingElementHiddenProp>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="Назначение в карту">
        <el-form
          size="mini"
          label-position="right"
          label-width="210px"
        >
          <el-row :gutter="100">
            <el-col :span="12">
              <el-form-item label="Текущая карта">
                <div v-if="node.model.card !== undefined && node.model.card">
                  <div>
                    {{ cardAppointmentText }}
                    <router-link
                      target="_blank"
                      :to="{ name: 'Card', params: { id: node.model.card_id } }"
                    >
                      <i class="fas fa-external-link-alt"></i>
                    </router-link>
                  </div>
                  <div>
                    <el-button
                      v-if="node.model.card_assign_type !== $cascadingConstants.elementCardAssign.types.TYPE_VQB"
                      :disabled="!node.isFieldEditable('card_id')"
                      size="mini"
                      icon="far fa-trash-alt"
                      @click="clearSelectedCard"
                    >
                      Удалить назначение
                    </el-button>
                  </div>
                </div>
                <CascadingElementHiddenProp v-else-if="node.model.card === undefined">{{node.getHiddenPlaceholder('card_id')}}</CascadingElementHiddenProp>
                <div v-else>Не назначено в карту</div>
              </el-form-item>

              <el-form-item>
                <span slot="label">
                  Назначение в карту
                  <el-popover
                    placement="top"
                    width="400"
                    trigger="click"
                  >
                    <el-button
                      slot="reference"
                      class="table-action-button open-desc-button"
                      type="text"
                      round
                      size="mini"
                      icon="fas fa-info-circle"
                    ></el-button>
                    <div style="white-space: pre-line">Конструктор отчетов позволяет запланировать назначение. Вы можете выбрать в какую карту должна будет быть назначена цель. А потом массово все такие цели назначить

                      Цель будет добавлена в первую карту, попавшую под условия.
                      Если необходимо добавить цель сразу в несколько карт - воспользуйтесь автоматическим каскадированием
                    </div>
                  </el-popover>
                </span>

                <div v-if="node.model.auto_cascaded">Цель добавлена автоматическим каскадированием</div>
                <div v-else-if="node.isFieldViewable('card_assign_type')">
                  <div style="display: flex; justify-content: space-between">
                    <div>
                      <el-radio-group
                        v-model="node.model.card_assign_type"
                        :disabled="!node.isFieldEditable('card_assign_type')"
                        size="small"
                        style="margin-bottom: 10px"
                        @change="updateNode"
                      >
                        <el-radio-button :label="null">Не назначается</el-radio-button>
                        <el-radio-button :label="1">Вручную</el-radio-button>
                        <el-radio-button :label="2">КО</el-radio-button>
                      </el-radio-group>
                    </div>

                    <div>
                      <el-button
                        :disabled="!node.isFieldEditable('card_assign_type')"
                        size="small"
                        icon="far fa-address-card"
                        @click="assignChildNodes"
                      >
                        Назначить дочерние КО
                      </el-button>
                    </div>
                  </div>


                  <div v-if="node.model.card_assign_type === $cascadingConstants.elementCardAssign.types.TYPE_MANUAL">
                    <cards-select-modal
                      @card-selected="cardSelected"
                    >
                      <el-button
                        slot="reference"
                        :disabled="!node.isFieldEditable('card_assign_type')"
                        size="mini"
                        icon="far fa-hand-pointer"
                      >
                        Выбрать карту
                      </el-button>
                    </cards-select-modal>

                  </div>

                  <div v-if="node.model.card_assign_type === $cascadingConstants.elementCardAssign.types.TYPE_VQB">
                    <el-button
                      :disabled="!node.isFieldEditable('card_assign_type')"
                      size="mini"
                      icon="far fa-address-card"
                      @click="assignNodeToCard(null)"
                    >
                      Назначить
                    </el-button>


                    <entity-saved-report-form
                      style="margin-top: -25px"
                      :disabled="!node.isFieldEditable('card_assign_type')"
                      :entity-type="$constants.visualQueryBuilder.formEntityTypes.TYPE_CASCADING_ELEMENT_CARD_ASSIGNMENTS"
                      :entity-id="node.model.id"
                      entity-report-key="cards"
                      delete-on-empty-search
                    ></entity-saved-report-form>

                  </div>
                </div>

              </el-form-item>
            </el-col>


            <el-col :span="12">
              <el-form-item label="Шкала карты">
                <CascadingCardScaleSelect
                  v-if="node.isFieldViewable('card_scale_id')"
                  :disabled="!node.isFieldEditable('card_scale_id')"
                  v-model="node.model"
                  @change="updateNode"
                ></CascadingCardScaleSelect>
                <CascadingElementHiddenProp v-else>{{node.getHiddenPlaceholder('card_scale_id')}}</CascadingElementHiddenProp>
              </el-form-item>
              <el-form-item label="Вес в карте">
                <click-to-edit
                  v-if="node.isFieldViewable('card_weight')"
                  :disabled="!node.isFieldEditable('card_weight')"
                  placeholder=""
                  digits-only
                  v-model="node.model.card_weight"
                  @input="updateNode"
                ></click-to-edit>
                <CascadingElementHiddenProp v-else>{{node.getHiddenPlaceholder('card_weight')}}</CascadingElementHiddenProp>
              </el-form-item>
              <el-form-item label="Результат карты">
                <div v-if="node.isFieldViewable('card_bonus')">{{ node.model.card_bonus }}%</div>
                <CascadingElementHiddenProp v-else>{{node.getHiddenPlaceholder('card_bonus')}}</CascadingElementHiddenProp>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>


      <el-tab-pane label="Каскадирование">
        <el-form
          size="mini"
          label-position="right"
          label-width="150px"
        >
          <el-row :gutter="100">
            <el-col :span="12">
              <el-form-item label="Автоматическое каскадирование">
                <div style="display: flex; justify-content: space-between">
                  <div>
                    <el-radio-group
                      v-if="node.isFieldViewable('auto_cascading_type')"
                      :disabled="!node.isFieldEditable('auto_cascading_type')"
                      v-model="node.model.auto_cascading_type"
                      size="small"
                      @change="updateNode"
                    >
                      <el-radio-button :label="null">Не каскадируется</el-radio-button>
                      <!--            <el-radio-button :label="1">Вручную</el-radio-button>-->
                      <el-radio-button :label="2">КО</el-radio-button>
                    </el-radio-group>
                    <CascadingElementHiddenProp v-else>{{node.getHiddenPlaceholder('auto_cascading_type')}}</CascadingElementHiddenProp>

                  </div>
                  <div>
                    <el-button
                      :disabled="!node.isFieldEditable('auto_cascading_type')"
                      size="small"
                      icon="fas fa-network-wired"
                      @click="runAutoCascadingChildren"
                    >
                      Каскадировать дочерние КО
                    </el-button>
                  </div>
                </div>


                <div v-if="node.model.auto_cascading_type">
                  <div>
                    Распределение базового и целевого значений
                    <click-to-edit
                      v-if="node.isFieldViewable('auto_cascading_target_partition_type')"
                      :disabled="!node.isFieldEditable('auto_cascading_target_partition_type')"
                      v-model="node.model.auto_cascading_target_partition_type"
                      type="select"
                      select-filterable
                      :select-options="$cascadingConstants.elementAutoCascading.targetPartitionTypesSelectOptions"
                      placeholder=""
                      @input="updateNode(node)"
                    ></click-to-edit>
                    <CascadingElementHiddenProp v-else>{{node.getHiddenPlaceholder('auto_cascading_target_partition_type')}}</CascadingElementHiddenProp>
                  </div>
                  <div>
                    Вес в карте
                    <click-to-edit
                      v-if="node.isFieldViewable('auto_cascading_card_weight')"
                      :disabled="!node.isFieldEditable('auto_cascading_card_weight')"
                      v-model="node.model.auto_cascading_card_weight"
                      digits-only
                      placeholder=""
                      @input="updateNode(node)"
                    ></click-to-edit>
                    <CascadingElementHiddenProp v-else>{{node.getHiddenPlaceholder('auto_cascading_card_weight')}}</CascadingElementHiddenProp>
                  </div>

                </div>


                <div v-if="node.model.auto_cascading_type === $cascadingConstants.elementAutoCascading.types.TYPE_VQB">
                  Условия каскадирования
                  <entity-saved-report-form
                    style="margin-top: -30px"
                    :disabled="!node.isFieldEditable('auto_cascading_type')"
                    :entity-type="$constants.visualQueryBuilder.formEntityTypes.TYPE_CASCADING_ELEMENT_AUTO_CASCADING"
                    :entity-id="node.model.id"
                    entity-report-key="cards"
                    delete-on-empty-search
                  ></entity-saved-report-form>

                  <div style="display: flex; justify-content: space-between">
                    <el-button
                      :disabled="!node.isFieldEditable('auto_cascading_type')"
                      size="small"
                      icon="fas fa-network-wired"
                      @click="runAutoCascading"
                    >
                      Каскадировать
                    </el-button>
                    <el-switch
                      v-if="node.isFieldViewable('auto_cascading_track_new_cards')"
                      v-model="node.model.auto_cascading_track_new_cards"
                      :disabled="!node.isFieldEditable('auto_cascading_track_new_cards')"
                      active-text="Следить за созданием новых карт"
                      @change="updateNode(node)"
                    ></el-switch>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </el-tab-pane>

      <el-tab-pane label="Полномочия">
        <el-form
          size="mini"
          label-position="right"
          label-width="200px"
        >

          <el-form-item label="Профиль полномочий">
            <CascadingPermissionsProfileSelect
              v-if="node.isFieldViewable('permissions_profile_id')"
              :disabled="!node.isFieldEditable('permissions_profile_id')"
              style="width: 500px"
              v-model="node.model"
              @change="updateNode"
            ></CascadingPermissionsProfileSelect>
            <CascadingElementHiddenProp v-else>{{node.getHiddenPlaceholder('permissions_profile_id')}}</CascadingElementHiddenProp>
          </el-form-item>

          <el-form-item label="Ответственный">
            <div>
              <div
                v-if="node.isFieldViewable('responsible_id')"
              >
                <div v-if="node.model.responsible">
                  <div>{{node.model.responsible.full_name}}</div>
                  <el-button
                    :disabled="!node.isFieldEditable('responsible_id')"
                    size="mini"
                    icon="fas fa-trash"
                    @click="clearResponsibleUser"
                  >
                    Удалить ответственного
                  </el-button>
                </div>
                <div v-else>Ответственный не назначен</div>
              </div>
              <CascadingElementHiddenProp v-else>{{node.getHiddenPlaceholder('responsible_id')}}</CascadingElementHiddenProp>
            </div>

            <add-users-dialog
              single-select
              title-text="Выбор сотрудника"
              add-button-text="Нажмите на строку для выбора"
              @users-selected="responsibleUserSelected"
            >
              <el-button
                slot="reference"
                :disabled="!node.isFieldEditable('responsible_id')"
                size="mini"
                icon="fas fa-user-friends"
              >
                Выбрать ответственного
              </el-button>
            </add-users-dialog>
          </el-form-item>


        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit.vue";
import CascadingScaleUnitSelect from "@/modules/cascading/components/scale/CascadingScaleUnitSelect.vue";
import CascadingScalePerformanceValuesInput
  from "@/modules/cascading/components/scale/CascadingScalePerformanceValuesInput.vue";
import PerformanceFormulaSelect from "@/modules/cascading/components/PerformanceFormula/PerformanceFormulaSelect.vue";
import CascadingCardScaleSelect from "@/modules/cascading/components/cardScale/CascadingCardScaleSelect.vue";
import EntitySavedReportForm from "@/components/report/builder/EntitySavedReportForm.vue";
import CardsSelectModal from "@/components/cards/CardSelectModal.vue";
import CascadingElementHiddenProp from "@/modules/cascading/components/CascadingElementHiddenProp.vue";
import AddUsersDialog from "@/components/user/AddUsersDialog.vue";
import CascadingPermissionsProfileSelect
  from "@/modules/cascading/components/permissionsProfile/CascadingPermissionsProfileSelect.vue";
import HistoryModal from "@/components/HistoryModal.vue";

export default {
  name: "ElementsTreeNodeSettingsPanel",
  components: {
    HistoryModal,
    CascadingPermissionsProfileSelect,
    AddUsersDialog,
    CascadingElementHiddenProp,
    CardsSelectModal,
    EntitySavedReportForm,
    CascadingCardScaleSelect,
    PerformanceFormulaSelect,
    CascadingScalePerformanceValuesInput,
    CascadingScaleUnitSelect,
    ClickToEdit
  },
  props: {
    node: { type: Object }
  },
  computed: {
    cardAppointmentText() {
      if (!this.node.model.card) {
        return "Не назначено в карту";
      }
      return this.node.model.card.user.full_name + " " + this.node.model.card.year;
    },
    valuesDisabled() {
      if (!this.node.hasChildren) {
        return false;
      }
      return this.node.model.child_values_aggregate_type !== this.$cascadingConstants.elementChildValuesAggregate.types.TYPE_MANUAL;
    },
    performanceDisabled() {
      if (!this.node.hasChildren) {
        return false;
      }
      return this.node.model.child_performance_aggregate_type !== this.$cascadingConstants.elementChildPerformanceAggregate.types.TYPE_MANUAL;
    }
  },
  data() {
    return {
      currentTab: null
    };
  },

  methods: {
    updateNode() {
      this.$emit("update-node", this.node);
    },
    updateNodeParentLink(parentLink) {
      this.$emit("update-node-parent-link", {
        node: this.node,
        parentLink: parentLink
      });
    },

    assignNodeToCard(cardId, withChild=false) {
      this.$emit("assign-node-to-card", {
        node: this.node,
        cardId: cardId,
        withChild: withChild,
      });
    },
    assignChildNodes() {
      this.$emit("assign-child-nodes", {
        node: this.node,
      });
    },
    cardSelected(card) {
      this.assignNodeToCard(card.id);
    },
    clearSelectedCard() {
      this.assignNodeToCard(null);
    },

    assignResponsible(userId) {
      this.node.model.responsible_id = userId;
      this.updateNode();
    },
    responsibleUserSelected(user) {
      this.assignResponsible(user.id);
    },
    clearResponsibleUser() {
      this.assignResponsible(null);
    },


    runAutoCascading() {
      this.$emit("run-auto-cascading", { node: this.node });
    },
    runAutoCascadingChildren() {
      this.$emit("run-auto-cascading-children", { node: this.node });
    },
  }

};
</script>

<style lang="scss">

</style>